import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractTokenPeriodFilter from "./AbstractTokenPeriodFilter.js";
import ClosingBalanceFormulaNode from "../../formula/ClosingBalanceFormulaNode.js";

/**
 * Period filter used for filtering data on the Closing Balance.
 */
export default class ClosingBalanceTokenPeriodFilter extends AbstractTokenPeriodFilter {
	_formulaNodeConstructor() {
		return ClosingBalanceFormulaNode;
	}

	static getLabel() {
		return _("Closing balance");
	}
}
